<template>
  <div>
    <van-list class="list" v-model="loading" loading-text="loadding..." :finished="finished" finished-text="" @load="getSellerList">
      <div v-if="sellerList.length > 0">
        <div class="item" v-for="(item, index) in sellerList" :key="index">
          <div class="item_head">
            <div class="fc-relative">
              <img class="user_photo" :src="item.img">
              <img class="flag" :src="item.logo">
            </div>
            <div class="user_info">
              <div class="title_ID">
                <span class="title fc-elip-2">{{ item.nickname }}</span>
                <!-- <span class="id">ID:{{item.userId}}</span> -->
                <div class="ids">
                  <span class="id">ID:{{ item.userId }}</span>
                  <img class="copyBtn" src="../assets/img/copy.png" @click="copyActiveCode($event, item.userId)">
                </div>
              </div>
              <div class="balance">
                <span class="balance_title fc-elip-1">{{ $t('m.buy_balance') }}</span>
                <img class="icon" src="../assets/img/diamond.png">
                <span class="num">{{ item.diamond }}</span>
              </div>
            </div>
          </div>
          <div class="paytype">
            <div class="paytype_list">
              <div class="imgbox" v-for="(pay, i) in item.payTypes">
                <img :src="pay.payTypeImg">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="sellerList.length < 1 && userInfo.userId" class="nodataImg">
        <img src="../assets/img/nodata.png" alt="">
      </div>
      <div v-if="sellerList.length < 1 && !userInfo.userId" class="noLogin">
        <div class="noLoginImg">
          <img src="../assets/img/noLogin.png" alt="">
          <p class="loginTip">{{ $t('m.login_after_recharge') }}</p>
        </div>
        <div class="fc-btn-line-login" @click="$router.push('/login')">{{ $t('m.login') }}</div>

      </div>
    </van-list>
  </div>

</template>
<script>
import Vue from 'vue';
import { List, Toast } from 'vant';
Vue.use(List);

import Clipboard from 'clipboard';
export default {
  name: "Sellers",
  props: {
    country: {
      type: Object,
      default: function () {
        return {
          coding: null
        }
      }
    }
  },
  data() {
    return {
      sellerList: [],
      page: 1, //当前页码
      loading: false,
      finished: false,
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    };
  },
  watch: {
    country: {
      handler(val) {
        console.log(val)
        this.sellerList = [];
        this.page = 1;
        this.finished = false;
        this.loading = false;

        this.getSellerList();
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {
    copyActiveCode(e, text) {
      console.log(e.target, text);
      const clipboard = new Clipboard(e.target, {
        text: () => String(text),
      })
      clipboard.on('success', e => {
        Toast(this.$t('m.copied'));
        // 释放内存
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        Toast('Failed');
        // 释放内存
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.onClick(e)
    },
    getSellerList() {
      this.loading = true;
      this.$axios({
        method: 'POST',
        headers: {
          "Content-Type": 'application/json',
        },
        data: JSON.stringify({
          "page": this.page,
          "size": 10,
          //"country": this.country.coding,
          "userId": this.userInfo.userId || null,
        }),
        url: process.env.weiApiUrl + '/api/h5/trade/account/coinAccountListPage',
      }).then(({ data }) => {
        this.loading = false;
        console.log('function getSellerList', data)
        if (data.code == 1) {
          if (this.page < 2) {
            if (data.data.list.length < 1) {
              this.finished = true;
              // this.sellerList = 'empty';
            } else {
              this.sellerList = data.data.list;
              this.page++;
            }
          } else {
            if (data.data.list.length < 1) {
              this.finished = true;
            }
            this.sellerList = this.sellerList.concat(data.data.list);
            this.page++;
          }
        } else {
          this.loading = false;
          this.finished = true;
        }
      }).catch(e => {
        this.loading = false;
        this.finished = true;
      });
    }
  },
};
</script>
<style scoped>
.fc-btn-line-login {
  min-width: 1.8rem;
  padding: 0.25rem 2rem;
  line-height: 1;
  border: 1px solid #008AFF;
  text-align: center;
  border-radius: 1rem;
  font-size: 0.26rem;
  background: #0084f9;
  color: #fff;
}

.noLogin {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 60vh;
}

.noLoginImg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.noLoginImg img {
  width: 2.5rem;
}

.loginTip {
  text-align: center;
  font-weight: bold;
  margin: 0.2rem 0;
}

.head .title {
  height: 1.14rem;
  margin-top: 1.4rem;
}

.nodataImg {
  width: 100%;
  display: flex;
  justify-content: center;
}


.nodataImg img {
  width: 30%;
}

.head .text {
  line-height: 1.5;
  padding: 0.2rem 0.3rem 0.4rem;
  display: flex;
  align-items: center;
  color: #fff;
  justify-content: center;
  text-align: center;
}

.maincon {
  width: 7.5rem;
  /* background-image: url('../img/head_bg.png'); */
  background-size: 100% 7.03rem;
  position: relative;
}

.content {
  background: #fff;
  border-radius: 0.24rem 0.24rem 0 0;
  padding: 0.16rem 0.3rem;
  position: relative;
}

.fc-relative {
  position: relative;
}

.list {
  /* margin-left: 0.1rem; */
}

.list .item {
  padding: .3rem;
  /* border-bottom: 1px solid #F2F2F2; */
  background-color: #fff;
  margin-bottom: .2rem;
}

.list .item_head {
  display: flex;
  align-items: center;
}

.list .item_head .user_photo {
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
}

.list .item_head .user_info {
  flex: 1;
  align-items: center;
  margin-left: 0.24rem;
}

.list .item_head .title_ID {
  display: flex;
  justify-content: space-between;
}

.list .item_head .title {
  font-size: 0.32rem;
  line-height: 1.1;
  font-weight: bold;
  word-break: break-word;
  max-width: 3.8rem;
}

/* .list .item_head .id {
  font-size: 0.24rem;
  color: #B3B3B3;
  width: 2.1rem;
  text-align: right;
} */
.ids {
  display: flex;
  /* align-items: center; */
}

.ids .id {
  font-size: .26rem;
  color: #61636B;
  font-weight: 600;
  line-height: .32rem;
  margin: 0 .08rem;
}

.ids .copyBtn {
  height: .32rem;
}

.list .item_head .balance {
  margin-top: 0.14rem;
  display: flex;
  align-items: center;
  font-size: 0.26rem;
  color: #1F1F1F;
}

.list .item_head .balance_title {
  max-width: 3.4rem;
}

.list .item_head .balance .icon {
  width: 0.36rem;
  margin-left: 0.24rem;
}

.list .item_head .balance .num {
  font-size: 0.32rem;
  color: #008AFF;
}

.paytype {
  width: 7rem;
  margin-top: 0.24rem;
}

.paytype_list {
  display: flex;
  width: 7.1rem;
  overflow-x: auto;
}

.paytype_list .box {
  margin-right: 0.3px;
}

.paytype .imgbox {
  flex: 0 0 1.26rem;
  height: 0.48rem;
  text-align: center;
  border: 1px solid #F2F2F2;
  border-radius: 0.04rem;
  margin-right: 0.08rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.paytype .imgbox img {
  max-width: 1.26rem;
  max-height: 0.48rem;
}

.paytype .imgbox:last-child {
  margin-right: 0.3rem;
}

.dataall {
  text-align: center;
  padding: 0.3rem 0 0.6rem;
}

.dataall img {
  width: 1.85rem;
}

.ar .maincon {
  /* background-image: url('../img/head_bg_ar.png'); */
}

.ar .list {
  margin-left: 0;
  margin-right: 0.1rem;
}

.ar .list .item_head .id {
  text-align: left;
}

.ar .list .item_head .balance .icon {
  margin-left: 0;
  margin-right: 0.24rem;
}

.ar .list .item_head .user_info {
  margin-right: 0.24rem;
  margin-left: 0;
}

.ar .imgbox {
  margin-left: 0.08rem;
  margin-right: 0;
}

.ar .imgbox:last-child {
  margin-left: 0.3rem;
  margin-right: 0;
}

.ar .flag {
  right: inherit;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/sellers.vue